module.exports = __webpack_public_path__ + "static/media/beian.d0289dc0.png";